<template>
  <section class="hero-section home-hero">
    <div class="hero-overlay"></div>
    <HeroLinks />

    <div class="hero-text">
      <div class="max-w-6xl mx-auto px-4 py-12">
        <div class="home-hero-content">
          <div class="mb-4">
            <h2 class="page-title">
              Transform Your Life Through World-Class Training.
              <span class="build">Build Your Empire</span>
            </h2>
          </div>
          <div class="mb-16">
            <p>6 Elite Programs, Expert Coaches, 1 Powerful Community</p>
          </div>
          <div class="mb-4">
            <ButtonLink 
              text="start your free trial"
              url="/free-trial"
              color="white-trans-yellow-black"
            />
          </div>
          <div class="mb-4">
            <p>Join 350+ members already training with us</p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <BorderHeroBottom />
</template>

<script>
  import BorderHeroBottom from './BorderHeroBottom.vue'
  import ButtonLink from '../Common/ButtonLink.vue'
  import HeroLinks from './HeroLinks.vue';

  export default {
    name: 'HomeHero',
    components: {
      BorderHeroBottom,
      ButtonLink,
      HeroLinks,
    },
  };
</script>

<style scoped>
  .home-hero {
    /* background-image: url('@/assets/images/home/home-bg.jpg'); */
    background-image: url('@/assets/images/home/gym-bg-16x9.png');
    min-height: 80vh;
    position: relative;
  }

  .hero-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* background: rgba(0, 0, 0, 0.5); */
    background: rgba(0, 0, 0, 0.8);
    z-index: 1;
  }

  .home-hero-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 3;
  }

  .home-hero-content .page-title {
    font-size: 3rem;
    font-weight: bold;
  }

  .build {
    color: var(--empire-yellow);
  }

  @media screen and (max-width: 767px) {
    .home-hero {
      background-position: -50px center;
      background-image: url('@/assets/images/home/gym-bg-1x1.png');
    }
  }
</style>
